import { formatShortDate, roundToTwoSigns } from '~/utils/format-date';

/** 01.10.2026 11:24 — как в макете, без «в» из общего formatDate */
export const formatDateTime = (date: string): string => {
  const d = new Date(date);
  return `${formatShortDate(d)} ${roundToTwoSigns(d.getHours())}:${roundToTwoSigns(d.getMinutes())}`;
};
